import { type FC, type PropsWithChildren } from 'react'
import { RedesignLayout } from '../components'

export const DefaultLayout: FC<PropsWithChildren> = ({ children }) => {
  return <RedesignLayout>{children}</RedesignLayout>
}
